import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: { input: string; output: string; }
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: { input: string; output: string; }
  /**
   * Allows use of a JSON String for input / output from the GraphQL schema.
   *
   * Use of this type is *not recommended* as you lose the benefits of having a defined, static
   * schema (one of the key benefits of GraphQL).
   */
  JSONString: { input: Record<string, unknown>; output: Record<string, unknown>; }
};

export type AiOutputStatusType = {
  __typename?: 'AIOutputStatusType';
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  fragmentsUsed: Array<Maybe<Scalars['String']['output']>>;
  promptSetKey: Scalars['String']['output'];
  promptVersion: Scalars['String']['output'];
};

export type Appointment = Node & {
  __typename?: 'Appointment';
  aiOutputs: Array<AiOutputStatusType>;
  appointmentType?: Maybe<Scalars['String']['output']>;
  audioTranscription?: Maybe<AudioTranscriptionStatusType>;
  clientPreSessionMood?: Maybe<ClientMood>;
  clientUserShortId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastEventTimestamp: Scalars['DateTime']['output'];
  patientShortId: Scalars['String']['output'];
  provider?: Maybe<PublicProvider>;
  providerId: Scalars['Int']['output'];
  shortId: Scalars['String']['output'];
  telehealthSessions?: Maybe<TelehealthSessionConnection>;
  timeEnd: Scalars['DateTime']['output'];
  timeStart: Scalars['DateTime']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type AppointmentTelehealthSessionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * a model to help our support team understand the status of an appointment's
 * AI outputs and audio transcription
 */
export type AppointmentAiSupportStatus = {
  __typename?: 'AppointmentAISupportStatus';
  aiOutput?: Maybe<AiOutputStatusType>;
  appointmentShortId: Scalars['String']['output'];
  audioTranscription?: Maybe<AudioTranscriptionStatusType>;
  clientUserShortId?: Maybe<Scalars['String']['output']>;
  inTranscriptionTestGroup?: Maybe<Scalars['Boolean']['output']>;
  lastUpdatedAt: Scalars['DateTime']['output'];
  providerShortId?: Maybe<Scalars['String']['output']>;
};

export type AppointmentCompletion = {
  __typename?: 'AppointmentCompletion';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  shortId: Scalars['String']['output'];
};

export type AppointmentConnection = {
  __typename?: 'AppointmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<AppointmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `Appointment` and its cursor. */
export type AppointmentEdge = {
  __typename?: 'AppointmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Appointment>;
};

export type AppointmentInfo = {
  __typename?: 'AppointmentInfo';
  clientUserShortId?: Maybe<Scalars['String']['output']>;
  hasProviderNoShowReport: Scalars['Boolean']['output'];
  shortId: Scalars['String']['output'];
  timeEnd: Scalars['DateTime']['output'];
  timeStart: Scalars['DateTime']['output'];
};

/** An enumeration. */
export enum AppointmentSortEnum {
  AppointmentTypeAsc = 'APPOINTMENT_TYPE_ASC',
  AppointmentTypeDesc = 'APPOINTMENT_TYPE_DESC',
  ClientUserShortIdAsc = 'CLIENT_USER_SHORT_ID_ASC',
  ClientUserShortIdDesc = 'CLIENT_USER_SHORT_ID_DESC',
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  IdAsc = 'ID_ASC',
  IdDesc = 'ID_DESC',
  LastEventTimestampAsc = 'LAST_EVENT_TIMESTAMP_ASC',
  LastEventTimestampDesc = 'LAST_EVENT_TIMESTAMP_DESC',
  PatientShortIdAsc = 'PATIENT_SHORT_ID_ASC',
  PatientShortIdDesc = 'PATIENT_SHORT_ID_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  TimeEndAsc = 'TIME_END_ASC',
  TimeEndDesc = 'TIME_END_DESC',
  TimeStartAsc = 'TIME_START_ASC',
  TimeStartDesc = 'TIME_START_DESC',
  UpdatedAtAsc = 'UPDATED_AT_ASC',
  UpdatedAtDesc = 'UPDATED_AT_DESC'
}

export type AudioTranscriptionStatusType = {
  __typename?: 'AudioTranscriptionStatusType';
  appointmentShortId: Scalars['String']['output'];
  pctSessionTranscribed?: Maybe<Scalars['Float']['output']>;
  recordingStatus?: Maybe<Scalars['String']['output']>;
  recordingStatusReason?: Maybe<Scalars['String']['output']>;
  transcriptionStatus?: Maybe<Scalars['String']['output']>;
  transcriptionStatusReason?: Maybe<Scalars['String']['output']>;
};

export type CancelDeadTasks = {
  __typename?: 'CancelDeadTasks';
  /** DeadTask IDs that were NOT successfully canceled. */
  errorDeadTaskIds: Array<Scalars['Int']['output']>;
  /** The error message corresponding to each ErrorDeadTaskID. */
  errorDetails: Array<Scalars['String']['output']>;
  /** DeadTask IDs that were successfully canceled. */
  successfulDeadTaskIds: Array<Scalars['Int']['output']>;
};

export type CancelOutboxTasks = {
  __typename?: 'CancelOutboxTasks';
  /** The error message corresponding to each ErrorOutboxTaskID. */
  errorDetails: Array<Scalars['String']['output']>;
  /** OutboxTask IDs that were NOT successfully canceled. */
  errorOutboxTaskIds: Array<Scalars['Int']['output']>;
  /** OutboxTask IDs that were successfully canceled. */
  successfulOutboxTaskIds: Array<Scalars['Int']['output']>;
};

export type ClientAppointment = Node & {
  __typename?: 'ClientAppointment';
  appointmentType?: Maybe<Scalars['String']['output']>;
  clientUserShortId?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  lastEventTimestamp: Scalars['DateTime']['output'];
  patientShortId: Scalars['String']['output'];
  /** The provider for this appointment */
  provider?: Maybe<PublicProvider>;
  providerId: Scalars['Int']['output'];
  shortId: Scalars['String']['output'];
  timeEnd: Scalars['DateTime']['output'];
  timeStart: Scalars['DateTime']['output'];
};

export type ClientAppointmentConnection = {
  __typename?: 'ClientAppointmentConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ClientAppointmentEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ClientAppointment` and its cursor. */
export type ClientAppointmentEdge = {
  __typename?: 'ClientAppointmentEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ClientAppointment>;
};

/** An enumeration. */
export enum ClientAppointmentSortEnum {
  AppointmentTypeAsc = 'APPOINTMENT_TYPE_ASC',
  AppointmentTypeDesc = 'APPOINTMENT_TYPE_DESC',
  ClientUserShortIdAsc = 'CLIENT_USER_SHORT_ID_ASC',
  ClientUserShortIdDesc = 'CLIENT_USER_SHORT_ID_DESC',
  CompletedAtAsc = 'COMPLETED_AT_ASC',
  CompletedAtDesc = 'COMPLETED_AT_DESC',
  LastEventTimestampAsc = 'LAST_EVENT_TIMESTAMP_ASC',
  LastEventTimestampDesc = 'LAST_EVENT_TIMESTAMP_DESC',
  PatientShortIdAsc = 'PATIENT_SHORT_ID_ASC',
  PatientShortIdDesc = 'PATIENT_SHORT_ID_DESC',
  ProviderIdAsc = 'PROVIDER_ID_ASC',
  ProviderIdDesc = 'PROVIDER_ID_DESC',
  ShortIdAsc = 'SHORT_ID_ASC',
  ShortIdDesc = 'SHORT_ID_DESC',
  TimeEndAsc = 'TIME_END_ASC',
  TimeEndDesc = 'TIME_END_DESC',
  TimeStartAsc = 'TIME_START_ASC',
  TimeStartDesc = 'TIME_START_DESC'
}

export type ClientMood = {
  __typename?: 'ClientMood';
  emotions: Array<Maybe<Scalars['String']['output']>>;
  /** The time of mood check-in */
  moodCheckinAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ClientTranscriptionConsent = {
  __typename?: 'ClientTranscriptionConsent';
  appointmentShortId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOptedIn: Scalars['Boolean']['output'];
  patientShortId: Scalars['String']['output'];
  providerShortId: Scalars['String']['output'];
  updateSource: Scalars['String']['output'];
  userAction?: Maybe<Scalars['String']['output']>;
};

export type CompleteTwilioSession = {
  __typename?: 'CompleteTwilioSession';
  roomSid: Scalars['String']['output'];
};

export type CreateTestAiOutput = {
  __typename?: 'CreateTestAIOutput';
  outputShortId: Scalars['String']['output'];
  providerAuth0Sub: Scalars['String']['output'];
  providerId: Scalars['Int']['output'];
};

export type CreateTestAppointment = {
  __typename?: 'CreateTestAppointment';
  appointmentShortId: Scalars['String']['output'];
  appointmentTimeEnd: Scalars['DateTime']['output'];
  appointmentTimeStart: Scalars['DateTime']['output'];
};

export type CreateTestUser = {
  __typename?: 'CreateTestUser';
  auth0Sub: Scalars['String']['output'];
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password: Scalars['String']['output'];
  shortId: Scalars['String']['output'];
};

export type CreateTestingTasks = {
  __typename?: 'CreateTestingTasks';
  numCreated?: Maybe<Scalars['Int']['output']>;
};

export type DeadTaskType = {
  __typename?: 'DeadTaskType';
  celeryTaskId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  deadTaskId?: Maybe<Scalars['String']['output']>;
  errorCount: Scalars['Int']['output'];
  errorDetails?: Maybe<Scalars['String']['output']>;
  errorType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['JSONString']['output']>;
  taskId: Scalars['String']['output'];
  taskName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedAtUtc?: Maybe<Scalars['DateTime']['output']>;
};

export type DeleteTestUser = {
  __typename?: 'DeleteTestUser';
  deletedAt: Scalars['DateTime']['output'];
};

export type DiarizedTranscriptSentenceType = {
  __typename?: 'DiarizedTranscriptSentenceType';
  content: Scalars['String']['output'];
  end: Scalars['Float']['output'];
  speaker: Scalars['String']['output'];
  start: Scalars['Float']['output'];
};

export type DiarizedTranscriptType = {
  __typename?: 'DiarizedTranscriptType';
  duration: Scalars['Float']['output'];
  sentences: Array<DiarizedTranscriptSentenceType>;
};

export type DisconnectTwilioParticipant = {
  __typename?: 'DisconnectTwilioParticipant';
  participantSid: Scalars['String']['output'];
  roomName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Eval = {
  __typename?: 'Eval';
  evalSetKey: Scalars['String']['output'];
  evalVersion: Scalars['String']['output'];
  evaluator: Scalars['String']['output'];
  flagged?: Maybe<Scalars['Boolean']['output']>;
  flaggedKeys?: Maybe<Array<Scalars['String']['output']>>;
  result?: Maybe<Scalars['String']['output']>;
};

export type GradingOutput = {
  __typename?: 'GradingOutput';
  appointmentShortId: Scalars['String']['output'];
  diarizedTranscript?: Maybe<DiarizedTranscriptType>;
  evals?: Maybe<Array<Eval>>;
  fragmentsUsed: Array<Scalars['String']['output']>;
  output: Scalars['String']['output'];
  promptSetKey: Scalars['String']['output'];
  promptVersion: Scalars['String']['output'];
  providerShortId: Scalars['String']['output'];
  transcript?: Maybe<Scalars['String']['output']>;
};

export type Interval = {
  __typename?: 'Interval';
  end: Scalars['DateTime']['output'];
  start: Scalars['DateTime']['output'];
};

/** Note: the monolith doesn't expose this over graphql and reads directly from the db. */
export type InvocationAuditObject = {
  __typename?: 'InvocationAuditObject';
  actor: Scalars['String']['output'];
  arguments: Array<Scalars['String']['output']>;
  invokedAt: Scalars['DateTime']['output'];
  runId: Scalars['String']['output'];
  scriptName: Scalars['String']['output'];
};

export type InvokeRegisteredScript = {
  __typename?: 'InvokeRegisteredScript';
  scriptRunId: Scalars['String']['output'];
};

export type LiveTranscriptIngestResult = {
  __typename?: 'LiveTranscriptIngestResult';
  accepted: Scalars['Boolean']['output'];
};

/** One finalized caption from the Zoom Video SDK, tagged client-side. */
export type LiveTranscriptSentenceInput = {
  content: Scalars['String']['input'];
  messageId: Scalars['String']['input'];
  participantIdentity: Scalars['String']['input'];
  participantUserId: Scalars['String']['input'];
  timestampMs: Scalars['Int']['input'];
  userType: Scalars['String']['input'];
};

export enum MeetingAccessEventType {
  Denied = 'DENIED',
  Granted = 'GRANTED'
}

export type Mutation = {
  __typename?: 'Mutation';
  cancelDeadTasks?: Maybe<CancelDeadTasks>;
  cancelOutboxTasks?: Maybe<CancelOutboxTasks>;
  completeTwilioSession?: Maybe<CompleteTwilioSession>;
  createTestAiOutput?: Maybe<CreateTestAiOutput>;
  createTestAppointment?: Maybe<CreateTestAppointment>;
  createTestPatient?: Maybe<CreateTestUser>;
  createTestProvider?: Maybe<CreateTestUser>;
  createTestingTasks?: Maybe<CreateTestingTasks>;
  createTwilioProviderChatAccess?: Maybe<TwilioAccess>;
  createTwilioProviderMeetingAccess?: Maybe<TwilioProviderMeetingAccess>;
  createTwilioSessionConversation?: Maybe<TwilioConversation>;
  createTwilioVisitorAccess?: Maybe<TwilioVisitorAccessDocAccess>;
  createTwilioVisitorChatAccess?: Maybe<TwilioAccess>;
  createTwilioVisitorPresenceMapAccess?: Maybe<TwilioVisitorPresenceMapAccess>;
  createTwilioWaitingRoomConversation?: Maybe<TwilioConversation>;
  deleteTestPatient?: Maybe<DeleteTestUser>;
  deleteTestProvider?: Maybe<DeleteTestUser>;
  disconnectTwilioParticipant?: Maybe<DisconnectTwilioParticipant>;
  getPresignedUrl?: Maybe<PresignedUrl>;
  ingestLiveTranscriptChunk?: Maybe<LiveTranscriptIngestResult>;
  invokeRegisteredScript?: Maybe<InvokeRegisteredScript>;
  markAppointmentCompleted?: Maybe<AppointmentCompletion>;
  recordClientMeasure?: Maybe<RecordedMeasure>;
  recordClientMood?: Maybe<RecordedMeasure>;
  recordClientTranscriptionConsent?: Maybe<ClientTranscriptionConsent>;
  recordProviderNoShowReport?: Maybe<ProviderNoShowReport>;
  recordProviderTranscriptionConsent?: Maybe<ProviderTranscriptionConsent>;
  recordUnaccompaniedParticipant?: Maybe<UnaccompaniedParticipant>;
  retryDeadTasks?: Maybe<RetryDeadTasks>;
  syncClientMood?: Maybe<RecordedMeasure>;
  updatePatientTelehealthPreference?: Maybe<PatientTelehealthPreference>;
  updateTwilioSessionConversation?: Maybe<TwilioConversationParticipant>;
  updateTwilioVisitorMeetingAccess?: Maybe<TwilioVisitorMeetingAccess>;
  updateTwilioVisitorPresence?: Maybe<TwilioVisitorPresence>;
};


export type MutationCancelDeadTasksArgs = {
  deadTaskIds: Array<Scalars['Int']['input']>;
};


export type MutationCancelOutboxTasksArgs = {
  outboxTaskIds: Array<Scalars['Int']['input']>;
};


export type MutationCompleteTwilioSessionArgs = {
  roomSid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTestAiOutputArgs = {
  output: Scalars['String']['input'];
};


export type MutationCreateTestAppointmentArgs = {
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  patientShortId: Scalars['String']['input'];
  providerShortId: Scalars['String']['input'];
  timeEnd?: InputMaybe<Scalars['DateTime']['input']>;
  timeStart?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateTestPatientArgs = {
  auth0Sub?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTestProviderArgs = {
  auth0Sub?: InputMaybe<Scalars['String']['input']>;
  shortId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateTestingTasksArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  queue?: InputMaybe<Scalars['String']['input']>;
  taskDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateTwilioProviderMeetingAccessArgs = {
  patientShortId: Scalars['String']['input'];
};


export type MutationCreateTwilioSessionConversationArgs = {
  roomSid: Scalars['String']['input'];
  visitorId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
};


export type MutationCreateTwilioVisitorAccessArgs = {
  providerShortId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
  visitorUuid: Scalars['String']['input'];
};


export type MutationCreateTwilioVisitorChatAccessArgs = {
  visitorId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
};


export type MutationCreateTwilioWaitingRoomConversationArgs = {
  providerShortId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
  visitorUuid: Scalars['String']['input'];
  waitingRoomConversationSid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteTestPatientArgs = {
  deleteAuth0?: InputMaybe<Scalars['Boolean']['input']>;
  shortId: Scalars['String']['input'];
};


export type MutationDeleteTestProviderArgs = {
  deleteAuth0?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['String']['input'];
};


export type MutationDisconnectTwilioParticipantArgs = {
  participantSid: Scalars['String']['input'];
  roomName: Scalars['String']['input'];
};


export type MutationGetPresignedUrlArgs = {
  appointmentShortId: Scalars['String']['input'];
  uploadMeta?: InputMaybe<UploadMeta>;
};


export type MutationIngestLiveTranscriptChunkArgs = {
  appointmentShortId: Scalars['String']['input'];
  sentences: Array<LiveTranscriptSentenceInput>;
};


export type MutationInvokeRegisteredScriptArgs = {
  actor: Scalars['String']['input'];
  args: Array<Scalars['String']['input']>;
  scriptName: Scalars['String']['input'];
};


export type MutationMarkAppointmentCompletedArgs = {
  appointmentShortId: Scalars['String']['input'];
};


export type MutationRecordClientMeasureArgs = {
  providerShortId?: InputMaybe<Scalars['String']['input']>;
  visitorId: Scalars['String']['input'];
};


export type MutationRecordClientMoodArgs = {
  emotions: Array<Scalars['String']['input']>;
  visitorId: Scalars['String']['input'];
};


export type MutationRecordClientTranscriptionConsentArgs = {
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  isOptedIn: Scalars['Boolean']['input'];
  patientShortId: Scalars['String']['input'];
  providerShortId: Scalars['String']['input'];
  updateSource: Scalars['String']['input'];
  userAction?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRecordProviderNoShowReportArgs = {
  appointmentShortId: Scalars['String']['input'];
  patientName: Scalars['String']['input'];
};


export type MutationRecordProviderTranscriptionConsentArgs = {
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  isOptedIn: Scalars['Boolean']['input'];
  providerShortId: Scalars['String']['input'];
  updateSource: Scalars['String']['input'];
};


export type MutationRecordUnaccompaniedParticipantArgs = {
  entityShortId: Scalars['String']['input'];
  entityType: UserType;
  name?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRetryDeadTasksArgs = {
  deadTaskIds: Array<Scalars['Int']['input']>;
};


export type MutationSyncClientMoodArgs = {
  emotions: Array<Scalars['String']['input']>;
  visitorId: Scalars['String']['input'];
};


export type MutationUpdatePatientTelehealthPreferenceArgs = {
  clientUserShortId: Scalars['String']['input'];
  isEnabled: Scalars['Boolean']['input'];
  patientShortId: Scalars['String']['input'];
  settingName: PatientTelehealthPreferenceSetting;
};


export type MutationUpdateTwilioSessionConversationArgs = {
  conversationSid: Scalars['String']['input'];
  visitorId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
};


export type MutationUpdateTwilioVisitorMeetingAccessArgs = {
  admissionTransactionId?: InputMaybe<Scalars['String']['input']>;
  conversationSid?: InputMaybe<Scalars['String']['input']>;
  eventType: MeetingAccessEventType;
  isZoomEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  patientShortId?: InputMaybe<Scalars['String']['input']>;
  roomName: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
  visitorUuid: Scalars['String']['input'];
};


export type MutationUpdateTwilioVisitorPresenceArgs = {
  admissionTime?: InputMaybe<Scalars['String']['input']>;
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  isInForeground?: InputMaybe<Scalars['Boolean']['input']>;
  isJoining?: InputMaybe<Scalars['Boolean']['input']>;
  joinRoomMode?: InputMaybe<Scalars['String']['input']>;
  patientShortId: Scalars['String']['input'];
  providerShortId: Scalars['String']['input'];
  videoPlatform?: InputMaybe<Scalars['String']['input']>;
  visitorName: Scalars['String']['input'];
  visitorUuid: Scalars['String']['input'];
  waitingRoomConversationSid?: InputMaybe<Scalars['String']['input']>;
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID']['output'];
};

export type OutboxTaskType = {
  __typename?: 'OutboxTaskType';
  createdAt: Scalars['DateTime']['output'];
  createdAtUtc?: Maybe<Scalars['DateTime']['output']>;
  errorCount: Scalars['Int']['output'];
  errorDetails?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  outboxTaskId?: Maybe<Scalars['String']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  params?: Maybe<Scalars['JSONString']['output']>;
  taskName: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  updatedAtUtc?: Maybe<Scalars['DateTime']['output']>;
};

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Information about a patient that is safe to expose to authenticated
 * client users
 */
export type PatientInfo = {
  __typename?: 'PatientInfo';
  preferredName?: Maybe<Scalars['String']['output']>;
};

export type PatientTelehealthPreference = {
  __typename?: 'PatientTelehealthPreference';
  id: Scalars['String']['output'];
  isEnabled: Scalars['Boolean']['output'];
  patientShortId: Scalars['String']['output'];
  settingName: PatientTelehealthPreferenceSetting;
};

/** An enumeration. */
export enum PatientTelehealthPreferenceSetting {
  SendSessionRecap = 'SEND_SESSION_RECAP'
}

export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  url?: Maybe<Scalars['String']['output']>;
};

export type ProviderInfo = {
  __typename?: 'ProviderInfo';
  image?: Maybe<Scalars['String']['output']>;
  isPrescriber: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  pronouns?: Maybe<Array<Scalars['String']['output']>>;
  shortId: Scalars['String']['output'];
};

export type ProviderNoShowReport = {
  __typename?: 'ProviderNoShowReport';
  appointmentShortId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
};

export type ProviderTelehealthPreference = Node & {
  __typename?: 'ProviderTelehealthPreference';
  createdAt: Scalars['DateTime']['output'];
  effectiveAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  isOptOut: Scalars['Boolean']['output'];
  providerShortId: Scalars['String']['output'];
};

export type ProviderTelehealthPreferenceConnection = {
  __typename?: 'ProviderTelehealthPreferenceConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProviderTelehealthPreferenceEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `ProviderTelehealthPreference` and its cursor. */
export type ProviderTelehealthPreferenceEdge = {
  __typename?: 'ProviderTelehealthPreferenceEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<ProviderTelehealthPreference>;
};

export type ProviderTelehealthPreferenceSelection = {
  __typename?: 'ProviderTelehealthPreferenceSelection';
  isOptOut?: Maybe<Scalars['Boolean']['output']>;
};

/** An enumeration. */
export enum ProviderTelehealthPreferenceSortEnum {
  CreatedAtAsc = 'CREATED_AT_ASC',
  CreatedAtDesc = 'CREATED_AT_DESC',
  EffectiveAtAsc = 'EFFECTIVE_AT_ASC',
  EffectiveAtDesc = 'EFFECTIVE_AT_DESC',
  IsOptOutAsc = 'IS_OPT_OUT_ASC',
  IsOptOutDesc = 'IS_OPT_OUT_DESC'
}

export type ProviderTranscriptionConsent = {
  __typename?: 'ProviderTranscriptionConsent';
  appointmentShortId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isOptedIn: Scalars['Boolean']['output'];
  providerShortId: Scalars['String']['output'];
  updateSource: Scalars['String']['output'];
};

export type PublicProvider = Node & {
  __typename?: 'PublicProvider';
  /** The ID of the object */
  id: Scalars['ID']['output'];
  /** Provider's image URL */
  image?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  pronouns: Array<Maybe<Scalars['String']['output']>>;
  shortId: Scalars['String']['output'];
  /** Provider's alternate telehealth link if opted-out of Grow telehealth */
  telehealthAlternateLink?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  aiOutput?: Maybe<Scalars['String']['output']>;
  aiSupportStatuses?: Maybe<Array<AppointmentAiSupportStatus>>;
  allTwilioEvents?: Maybe<TwilioEventConnection>;
  clientMood?: Maybe<ClientMood>;
  clientTranscriptionConsent?: Maybe<ClientTranscriptionConsent>;
  clientTranscriptionConsents: Array<ClientTranscriptionConsent>;
  currentProvider?: Maybe<ProviderInfo>;
  currentProviderTelehealthPreference?: Maybe<ProviderTelehealthPreferenceSelection>;
  deadTasks?: Maybe<Array<Maybe<DeadTaskType>>>;
  evaluationGradingOutputs?: Maybe<Array<GradingOutput>>;
  gradingOutputs?: Maybe<Array<GradingOutput>>;
  invocationAudits: Array<InvocationAuditObject>;
  isValidProviderAndPatient: Scalars['Boolean']['output'];
  /** A complete, unsorted list of provider short IDs for any providers that are currently opted out from telehealth. Requires machine-to-machine authentication. */
  optedOutProviderShortIds: Array<Maybe<Scalars['String']['output']>>;
  outboxTasks?: Maybe<Array<Maybe<OutboxTaskType>>>;
  patientInfo?: Maybe<PatientInfo>;
  patientTelehealthPreference?: Maybe<PatientTelehealthPreference>;
  provider?: Maybe<PublicProvider>;
  providerTelehealthPreferences?: Maybe<ProviderTelehealthPreferenceConnection>;
  providerTranscriptionConsent?: Maybe<ProviderTranscriptionConsent>;
  providerTranscriptionConsents: Array<ProviderTranscriptionConsent>;
  registeredScripts: Array<RegisteredScriptObject>;
  sessionIntervals?: Maybe<SessionIntervals>;
  sessionTimeline?: Maybe<SessionTimeline>;
  telehealthSessionInfo?: Maybe<TelehealthSessionInfo>;
  testAiOutput?: Maybe<Scalars['String']['output']>;
  transcriptForGrading?: Maybe<TranscriptForGrading>;
  transcriptsForInvestigation: TranscriptsForInvestigationResult;
  twilioEventsForAppointment?: Maybe<TwilioEventConnection>;
  upcomingAppointments?: Maybe<AppointmentConnection>;
  upcomingPatientAppointments?: Maybe<ClientAppointmentConnection>;
  verifiedAiOutput?: Maybe<Scalars['String']['output']>;
};


export type QueryAiOutputArgs = {
  outputShortId: Scalars['String']['input'];
};


export type QueryAiSupportStatusesArgs = {
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  clientUserShortId?: InputMaybe<Scalars['String']['input']>;
  providerShortId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAllTwilioEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryClientMoodArgs = {
  visitorId: Scalars['String']['input'];
};


export type QueryClientTranscriptionConsentArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  patientShortId: Scalars['String']['input'];
};


export type QueryClientTranscriptionConsentsArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  patientShortIds: Array<Scalars['String']['input']>;
};


export type QueryEvaluationGradingOutputsArgs = {
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  evalFlagged?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  passphrase: Scalars['String']['input'];
  promptSetKey?: InputMaybe<Scalars['String']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  providerShortId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGradingOutputsArgs = {
  afterDate?: InputMaybe<Scalars['Date']['input']>;
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  beforeDate?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  passphrase: Scalars['String']['input'];
  promptSetKey?: InputMaybe<Scalars['String']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  providerShortId?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvocationAuditsArgs = {
  scriptName: Scalars['String']['input'];
};


export type QueryIsValidProviderAndPatientArgs = {
  patientShortId: Scalars['ID']['input'];
  providerShortId: Scalars['ID']['input'];
};


export type QueryPatientInfoArgs = {
  patientShortId: Scalars['String']['input'];
};


export type QueryPatientTelehealthPreferenceArgs = {
  patientShortId: Scalars['String']['input'];
  settingName: PatientTelehealthPreferenceSetting;
};


export type QueryProviderArgs = {
  providerShortId: Scalars['String']['input'];
};


export type QueryProviderTelehealthPreferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  providerShortId?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ProviderTelehealthPreferenceSortEnum>>>;
};


export type QueryProviderTranscriptionConsentArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  providerShortId: Scalars['String']['input'];
};


export type QueryProviderTranscriptionConsentsArgs = {
  asOf?: InputMaybe<Scalars['DateTime']['input']>;
  providerShortIds: Array<Scalars['String']['input']>;
};


export type QuerySessionIntervalsArgs = {
  appointmentShortId: Scalars['String']['input'];
};


export type QuerySessionTimelineArgs = {
  appointmentShortId: Scalars['String']['input'];
  includePii?: InputMaybe<Scalars['Boolean']['input']>;
  patientShortId?: InputMaybe<Scalars['String']['input']>;
  providerShortId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTelehealthSessionInfoArgs = {
  patientShortId?: InputMaybe<Scalars['String']['input']>;
  providerShortId: Scalars['String']['input'];
};


export type QueryTestAiOutputArgs = {
  outputShortId: Scalars['String']['input'];
  providerId: Scalars['Int']['input'];
};


export type QueryTranscriptForGradingArgs = {
  appointmentShortId: Scalars['String']['input'];
  passphrase: Scalars['String']['input'];
};


export type QueryTranscriptsForInvestigationArgs = {
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  clientUserShortId?: InputMaybe<Scalars['String']['input']>;
  lookbackDays?: InputMaybe<Scalars['Int']['input']>;
  passphrase: Scalars['String']['input'];
};


export type QueryTwilioEventsForAppointmentArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  appointmentShortId: Scalars['String']['input'];
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUpcomingAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<AppointmentSortEnum>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUpcomingPatientAppointmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  clientUserShortId: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<ClientAppointmentSortEnum>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifiedAiOutputArgs = {
  appointmentShortId: Scalars['String']['input'];
  outputShortId: Scalars['String']['input'];
  providerShortId: Scalars['String']['input'];
};

export type RecordedMeasure = {
  __typename?: 'RecordedMeasure';
  recordedAt: Scalars['DateTime']['output'];
};

export type RegisteredScriptObject = {
  __typename?: 'RegisteredScriptObject';
  helpText: Scalars['String']['output'];
  name: Scalars['String']['output'];
  owner: Scalars['String']['output'];
  timeout: Scalars['Int']['output'];
};

export type RetryDeadTasks = {
  __typename?: 'RetryDeadTasks';
  /** DeadTask IDs that were NOT successfully re-enqueued. */
  errorDeadTaskIds: Array<Scalars['Int']['output']>;
  /** The error message corresponding to each ErrorDeadTaskID. */
  errorDetails: Array<Scalars['String']['output']>;
  /** DeadTask IDs that were successfully re-enqueued. */
  successfulDeadTaskIds: Array<Scalars['Int']['output']>;
};

export type SessionIntervals = {
  __typename?: 'SessionIntervals';
  appointmentShortId: Scalars['String']['output'];
  intervals: Array<Interval>;
};

export type SessionTimeline = {
  __typename?: 'SessionTimeline';
  events: Array<TimelineEvent>;
  sessionResultType?: Maybe<TelehealthSessionResultType>;
};

export type TelehealthSession = Node & {
  __typename?: 'TelehealthSession';
  appointment?: Maybe<ClientAppointment>;
  appointmentId?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  participants: Array<TelehealthSessionParticipant>;
  roomSid: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoPlatform?: Maybe<Scalars['String']['output']>;
};

export type TelehealthSessionConnection = {
  __typename?: 'TelehealthSessionConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TelehealthSessionEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TelehealthSession` and its cursor. */
export type TelehealthSessionEdge = {
  __typename?: 'TelehealthSessionEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TelehealthSession>;
};

export type TelehealthSessionInfo = {
  __typename?: 'TelehealthSessionInfo';
  appointment?: Maybe<AppointmentInfo>;
  provider: ProviderInfo;
};

export type TelehealthSessionParticipant = Node & {
  __typename?: 'TelehealthSessionParticipant';
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  disconnectedAt?: Maybe<Scalars['DateTime']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The ID of the object */
  id: Scalars['ID']['output'];
  participantIdentity: Scalars['String']['output'];
  participantSid: Scalars['String']['output'];
  participantType: Scalars['String']['output'];
  roomSid: Scalars['String']['output'];
  telehealthSession?: Maybe<TelehealthSession>;
  telehealthSessionId?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoPlatform?: Maybe<Scalars['String']['output']>;
};

/** An enumeration. */
export enum TelehealthSessionResultType {
  ClientAndProviderEnterThenLeave = 'CLIENT_AND_PROVIDER_ENTER_THEN_LEAVE',
  ClientEnterThenLeave = 'CLIENT_ENTER_THEN_LEAVE',
  ClientNoShow = 'CLIENT_NO_SHOW',
  Completed = 'COMPLETED',
  NoParticipants = 'NO_PARTICIPANTS',
  ParticipantsInWaitingRoom = 'PARTICIPANTS_IN_WAITING_ROOM',
  ProviderAndClientEnterThenLeave = 'PROVIDER_AND_CLIENT_ENTER_THEN_LEAVE',
  ProviderEnterThenLeave = 'PROVIDER_ENTER_THEN_LEAVE',
  ProviderNoShow = 'PROVIDER_NO_SHOW',
  Unknown = 'UNKNOWN'
}

export type TimelineEvent = {
  __typename?: 'TimelineEvent';
  event: Scalars['String']['output'];
  timestamp: Scalars['DateTime']['output'];
};

export type TranscriptForGrading = {
  __typename?: 'TranscriptForGrading';
  appointmentShortId: Scalars['String']['output'];
  diarizedTranscript?: Maybe<DiarizedTranscriptType>;
  providerShortId: Scalars['String']['output'];
  transcript: Scalars['String']['output'];
};

export type TranscriptForInvestigation = {
  __typename?: 'TranscriptForInvestigation';
  appointmentShortId: Scalars['String']['output'];
  diarizedTranscript?: Maybe<DiarizedTranscriptType>;
  transcript?: Maybe<Scalars['String']['output']>;
  transcriptMissingReason?: Maybe<Scalars['String']['output']>;
};

export type TranscriptsForInvestigationResult = {
  __typename?: 'TranscriptsForInvestigationResult';
  effectiveLookbackDays?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  totalMatchCount: Scalars['Int']['output'];
  transcripts: Array<TranscriptForInvestigation>;
  truncated: Scalars['Boolean']['output'];
};

export type TwilioAccess = {
  __typename?: 'TwilioAccess';
  jwt: Scalars['String']['output'];
};

export type TwilioConversation = {
  __typename?: 'TwilioConversation';
  conversationName: Scalars['String']['output'];
  conversationSid: Scalars['String']['output'];
  dateClosed?: Maybe<Scalars['String']['output']>;
  dateInactive?: Maybe<Scalars['String']['output']>;
};

export type TwilioConversationParticipant = {
  __typename?: 'TwilioConversationParticipant';
  participantSid: Scalars['String']['output'];
};

export type TwilioEvent = Node & {
  __typename?: 'TwilioEvent';
  accountSid?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  /** The ID of the object */
  id: Scalars['ID']['output'];
  participantDuration?: Maybe<Scalars['Int']['output']>;
  participantIdentity?: Maybe<Scalars['String']['output']>;
  participantSid?: Maybe<Scalars['String']['output']>;
  participantStatus?: Maybe<Scalars['String']['output']>;
  rawEvent: Scalars['JSONString']['output'];
  roomDuration?: Maybe<Scalars['Int']['output']>;
  roomName?: Maybe<Scalars['String']['output']>;
  roomSid?: Maybe<Scalars['String']['output']>;
  roomStatus?: Maybe<Scalars['String']['output']>;
  statusCallbackEvent?: Maybe<Scalars['String']['output']>;
  timestamp: Scalars['DateTime']['output'];
  trackKind?: Maybe<Scalars['String']['output']>;
  trackName?: Maybe<Scalars['String']['output']>;
  trackSid?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  videoPlatform?: Maybe<Scalars['String']['output']>;
};

export type TwilioEventConnection = {
  __typename?: 'TwilioEventConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<TwilioEventEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** A Relay edge containing a `TwilioEvent` and its cursor. */
export type TwilioEventEdge = {
  __typename?: 'TwilioEventEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<TwilioEvent>;
};

export type TwilioProviderMeetingAccess = {
  __typename?: 'TwilioProviderMeetingAccess';
  appointmentShortId?: Maybe<Scalars['String']['output']>;
  jwt: Scalars['String']['output'];
  roomName: Scalars['String']['output'];
  zoomJwt: Scalars['String']['output'];
};

export type TwilioVisitorAccessDocAccess = {
  __typename?: 'TwilioVisitorAccessDocAccess';
  jwt: Scalars['String']['output'];
  visitorAccessDocSid: Scalars['String']['output'];
};

export type TwilioVisitorMeetingAccess = {
  __typename?: 'TwilioVisitorMeetingAccess';
  admissionTime: Scalars['String']['output'];
  appointmentShortId?: Maybe<Scalars['String']['output']>;
  eventType: MeetingAccessEventType;
  updatedAt: Scalars['DateTime']['output'];
};

export type TwilioVisitorPresence = {
  __typename?: 'TwilioVisitorPresence';
  appPlatform?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type TwilioVisitorPresenceMapAccess = {
  __typename?: 'TwilioVisitorPresenceMapAccess';
  jwt: Scalars['String']['output'];
  visitorPresenceMapSid: Scalars['String']['output'];
};

export type UnaccompaniedParticipant = {
  __typename?: 'UnaccompaniedParticipant';
  appointmentShortId?: Maybe<Scalars['String']['output']>;
  entityShortId: Scalars['String']['output'];
  entityType: UserType;
  firstReportedAt: Scalars['DateTime']['output'];
  lastReportedAt: Scalars['DateTime']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type UploadMeta = {
  contentLength?: InputMaybe<Scalars['Int']['input']>;
  contentType?: InputMaybe<Scalars['String']['input']>;
};

/** An enumeration. */
export enum UserType {
  Client = 'CLIENT',
  Provider = 'PROVIDER'
}

export type GetTelehealthSessionInfoQueryVariables = Exact<{
  providerShortId: Scalars['String']['input'];
  patientShortId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetTelehealthSessionInfoQuery = { __typename?: 'Query', telehealthSessionInfo?: { __typename?: 'TelehealthSessionInfo', provider: { __typename?: 'ProviderInfo', name: string, shortId: string, image?: string | null, pronouns?: Array<string> | null, isPrescriber: boolean }, appointment?: { __typename?: 'AppointmentInfo', hasProviderNoShowReport: boolean, timeStart: string, clientUserShortId?: string | null, timeEnd: string, shortId: string } | null } | null };

export type IsValidProviderAndPatientQueryVariables = Exact<{
  providerShortId: Scalars['ID']['input'];
  patientShortId: Scalars['ID']['input'];
}>;


export type IsValidProviderAndPatientQuery = { __typename?: 'Query', isValidProviderAndPatient: boolean };

export type CreateTwilioProviderChatAccessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateTwilioProviderChatAccessMutation = { __typename?: 'Mutation', createTwilioProviderChatAccess?: { __typename?: 'TwilioAccess', jwt: string } | null };

export type CreateTwilioSessionConversationMutationVariables = Exact<{
  roomSid: Scalars['String']['input'];
  visitorId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
}>;


export type CreateTwilioSessionConversationMutation = { __typename?: 'Mutation', createTwilioSessionConversation?: { __typename?: 'TwilioConversation', conversationSid: string } | null };

export type UpdateTwilioSessionConversationMutationVariables = Exact<{
  conversationSid: Scalars['String']['input'];
  visitorId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
}>;


export type UpdateTwilioSessionConversationMutation = { __typename?: 'Mutation', updateTwilioSessionConversation?: { __typename?: 'TwilioConversationParticipant', participantSid: string } | null };

export type UpdateTwilioVisitorMeetingAccessMutationVariables = Exact<{
  conversationSid?: InputMaybe<Scalars['String']['input']>;
  roomName: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
  visitorUuid: Scalars['String']['input'];
  eventType: MeetingAccessEventType;
  patientShortId?: InputMaybe<Scalars['String']['input']>;
  isZoomEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  admissionTransactionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTwilioVisitorMeetingAccessMutation = { __typename?: 'Mutation', updateTwilioVisitorMeetingAccess?: { __typename?: 'TwilioVisitorMeetingAccess', eventType: MeetingAccessEventType, updatedAt: string, admissionTime: string } | null };

export type CreateTwilioProviderMeetingAccessMutationVariables = Exact<{
  patientShortId: Scalars['String']['input'];
}>;


export type CreateTwilioProviderMeetingAccessMutation = { __typename?: 'Mutation', createTwilioProviderMeetingAccess?: { __typename?: 'TwilioProviderMeetingAccess', jwt: string, appointmentShortId?: string | null, zoomJwt: string } | null };

export type MarkAppointmentCompletedMutationVariables = Exact<{
  appointmentShortId: Scalars['String']['input'];
}>;


export type MarkAppointmentCompletedMutation = { __typename?: 'Mutation', markAppointmentCompleted?: { __typename?: 'AppointmentCompletion', shortId: string, completedAt?: string | null } | null };

export type GetPresignedUrlMutationVariables = Exact<{
  appointmentShortId: Scalars['String']['input'];
  uploadMeta?: InputMaybe<UploadMeta>;
}>;


export type GetPresignedUrlMutation = { __typename?: 'Mutation', getPresignedUrl?: { __typename?: 'PresignedUrl', url?: string | null } | null };

export type GetProviderPatientTranscriptionConsentQueryVariables = Exact<{
  patientShortId: Scalars['String']['input'];
  providerShortId: Scalars['String']['input'];
}>;


export type GetProviderPatientTranscriptionConsentQuery = { __typename?: 'Query', clientTranscriptionConsent?: { __typename?: 'ClientTranscriptionConsent', isOptedIn: boolean, updateSource: string } | null, providerTranscriptionConsent?: { __typename?: 'ProviderTranscriptionConsent', isOptedIn: boolean, updateSource: string } | null };

export type GetProviderTranscriptionConsentQueryVariables = Exact<{
  providerShortId: Scalars['String']['input'];
}>;


export type GetProviderTranscriptionConsentQuery = { __typename?: 'Query', providerTranscriptionConsent?: { __typename?: 'ProviderTranscriptionConsent', isOptedIn: boolean, updateSource: string } | null };

export type RecordProviderTranscriptionConsentMutationVariables = Exact<{
  providerShortId: Scalars['String']['input'];
  isOptedIn: Scalars['Boolean']['input'];
  updateSource: Scalars['String']['input'];
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordProviderTranscriptionConsentMutation = { __typename?: 'Mutation', recordProviderTranscriptionConsent?: { __typename?: 'ProviderTranscriptionConsent', providerShortId: string, isOptedIn: boolean, createdAt: string } | null };

export type CreateTwilioVisitorPresenceMapAccessMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateTwilioVisitorPresenceMapAccessMutation = { __typename?: 'Mutation', createTwilioVisitorPresenceMapAccess?: { __typename?: 'TwilioVisitorPresenceMapAccess', jwt: string, visitorPresenceMapSid: string } | null };

export type DisconnectTwilioParticipantMutationVariables = Exact<{
  roomName: Scalars['String']['input'];
  participantSid: Scalars['String']['input'];
}>;


export type DisconnectTwilioParticipantMutation = { __typename?: 'Mutation', disconnectTwilioParticipant?: { __typename?: 'DisconnectTwilioParticipant', roomName: string, participantSid: string } | null };

export type GetCurrentProviderQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentProviderQuery = { __typename?: 'Query', currentProvider?: { __typename?: 'ProviderInfo', shortId: string, name: string, image?: string | null, pronouns?: Array<string> | null, isPrescriber: boolean } | null };

export type RecordUnaccompaniedParticipantMutationVariables = Exact<{
  entityShortId: Scalars['String']['input'];
  entityType: UserType;
  name: Scalars['String']['input'];
}>;


export type RecordUnaccompaniedParticipantMutation = { __typename?: 'Mutation', recordUnaccompaniedParticipant?: { __typename?: 'UnaccompaniedParticipant', entityShortId: string } | null };

export type RecordClientTranscriptionConsentMutationVariables = Exact<{
  patientShortId: Scalars['String']['input'];
  providerShortId: Scalars['String']['input'];
  isOptedIn: Scalars['Boolean']['input'];
  updateSource: Scalars['String']['input'];
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  userAction?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordClientTranscriptionConsentMutation = { __typename?: 'Mutation', recordClientTranscriptionConsent?: { __typename?: 'ClientTranscriptionConsent', patientShortId: string, isOptedIn: boolean, createdAt: string } | null };

export type GetCurrentPatientQueryVariables = Exact<{
  patientShortId: Scalars['String']['input'];
}>;


export type GetCurrentPatientQuery = { __typename?: 'Query', patientInfo?: { __typename?: 'PatientInfo', preferredName?: string | null } | null };

export type RecordClientMeasureVisitorMutationVariables = Exact<{
  visitorId: Scalars['String']['input'];
  providerShortId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecordClientMeasureVisitorMutation = { __typename?: 'Mutation', recordClientMeasure?: { __typename?: 'RecordedMeasure', recordedAt: string } | null };

export type CreateTwilioVisitorChatExperienceMutationVariables = Exact<{
  providerShortId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
  visitorId: Scalars['String']['input'];
}>;


export type CreateTwilioVisitorChatExperienceMutation = { __typename?: 'Mutation', createTwilioVisitorChatAccess?: { __typename?: 'TwilioAccess', jwt: string } | null, createTwilioWaitingRoomConversation?: { __typename?: 'TwilioConversation', conversationSid: string } | null };

export type CreateTwilioVisitorAccessDocTokenMutationVariables = Exact<{
  providerShortId: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
  visitorUuid: Scalars['String']['input'];
}>;


export type CreateTwilioVisitorAccessDocTokenMutation = { __typename?: 'Mutation', createTwilioVisitorAccess?: { __typename?: 'TwilioVisitorAccessDocAccess', jwt: string, visitorAccessDocSid: string } | null };

export type RecordProviderNoShowReportMutationVariables = Exact<{
  appointmentShortId: Scalars['String']['input'];
  patientName: Scalars['String']['input'];
}>;


export type RecordProviderNoShowReportMutation = { __typename?: 'Mutation', recordProviderNoShowReport?: { __typename?: 'ProviderNoShowReport', appointmentShortId: string, createdAt: string } | null };

export type UpdateVisitorPresenceMutationVariables = Exact<{
  providerShortId: Scalars['String']['input'];
  patientShortId: Scalars['String']['input'];
  appointmentShortId?: InputMaybe<Scalars['String']['input']>;
  visitorUuid: Scalars['String']['input'];
  visitorName: Scalars['String']['input'];
  waitingRoomConversationSid?: InputMaybe<Scalars['String']['input']>;
  videoPlatform?: InputMaybe<Scalars['String']['input']>;
  joinRoomMode?: InputMaybe<Scalars['String']['input']>;
  admissionTime?: InputMaybe<Scalars['String']['input']>;
  isInForeground?: InputMaybe<Scalars['Boolean']['input']>;
  isJoining?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateVisitorPresenceMutation = { __typename?: 'Mutation', updateTwilioVisitorPresence?: { __typename?: 'TwilioVisitorPresence', updatedAt: string } | null };


export const GetTelehealthSessionInfoDocument = gql`
    query GetTelehealthSessionInfo($providerShortId: String!, $patientShortId: String) {
  telehealthSessionInfo(
    providerShortId: $providerShortId
    patientShortId: $patientShortId
  ) {
    provider {
      name
      shortId
      image
      pronouns
      isPrescriber
    }
    appointment {
      hasProviderNoShowReport
      timeStart
      clientUserShortId
      timeEnd
      shortId
    }
  }
}
    `;

/**
 * __useGetTelehealthSessionInfoQuery__
 *
 * To run a query within a React component, call `useGetTelehealthSessionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTelehealthSessionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTelehealthSessionInfoQuery({
 *   variables: {
 *      providerShortId: // value for 'providerShortId'
 *      patientShortId: // value for 'patientShortId'
 *   },
 * });
 */
export function useGetTelehealthSessionInfoQuery(baseOptions: Apollo.QueryHookOptions<GetTelehealthSessionInfoQuery, GetTelehealthSessionInfoQueryVariables> & ({ variables: GetTelehealthSessionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTelehealthSessionInfoQuery, GetTelehealthSessionInfoQueryVariables>(GetTelehealthSessionInfoDocument, options);
      }
export function useGetTelehealthSessionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTelehealthSessionInfoQuery, GetTelehealthSessionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTelehealthSessionInfoQuery, GetTelehealthSessionInfoQueryVariables>(GetTelehealthSessionInfoDocument, options);
        }
export function useGetTelehealthSessionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTelehealthSessionInfoQuery, GetTelehealthSessionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTelehealthSessionInfoQuery, GetTelehealthSessionInfoQueryVariables>(GetTelehealthSessionInfoDocument, options);
        }
export type GetTelehealthSessionInfoQueryHookResult = ReturnType<typeof useGetTelehealthSessionInfoQuery>;
export type GetTelehealthSessionInfoLazyQueryHookResult = ReturnType<typeof useGetTelehealthSessionInfoLazyQuery>;
export type GetTelehealthSessionInfoSuspenseQueryHookResult = ReturnType<typeof useGetTelehealthSessionInfoSuspenseQuery>;
export type GetTelehealthSessionInfoQueryResult = Apollo.QueryResult<GetTelehealthSessionInfoQuery, GetTelehealthSessionInfoQueryVariables>;
export const IsValidProviderAndPatientDocument = gql`
    query IsValidProviderAndPatient($providerShortId: ID!, $patientShortId: ID!) {
  isValidProviderAndPatient(
    providerShortId: $providerShortId
    patientShortId: $patientShortId
  )
}
    `;

/**
 * __useIsValidProviderAndPatientQuery__
 *
 * To run a query within a React component, call `useIsValidProviderAndPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsValidProviderAndPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsValidProviderAndPatientQuery({
 *   variables: {
 *      providerShortId: // value for 'providerShortId'
 *      patientShortId: // value for 'patientShortId'
 *   },
 * });
 */
export function useIsValidProviderAndPatientQuery(baseOptions: Apollo.QueryHookOptions<IsValidProviderAndPatientQuery, IsValidProviderAndPatientQueryVariables> & ({ variables: IsValidProviderAndPatientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsValidProviderAndPatientQuery, IsValidProviderAndPatientQueryVariables>(IsValidProviderAndPatientDocument, options);
      }
export function useIsValidProviderAndPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsValidProviderAndPatientQuery, IsValidProviderAndPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsValidProviderAndPatientQuery, IsValidProviderAndPatientQueryVariables>(IsValidProviderAndPatientDocument, options);
        }
export function useIsValidProviderAndPatientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IsValidProviderAndPatientQuery, IsValidProviderAndPatientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsValidProviderAndPatientQuery, IsValidProviderAndPatientQueryVariables>(IsValidProviderAndPatientDocument, options);
        }
export type IsValidProviderAndPatientQueryHookResult = ReturnType<typeof useIsValidProviderAndPatientQuery>;
export type IsValidProviderAndPatientLazyQueryHookResult = ReturnType<typeof useIsValidProviderAndPatientLazyQuery>;
export type IsValidProviderAndPatientSuspenseQueryHookResult = ReturnType<typeof useIsValidProviderAndPatientSuspenseQuery>;
export type IsValidProviderAndPatientQueryResult = Apollo.QueryResult<IsValidProviderAndPatientQuery, IsValidProviderAndPatientQueryVariables>;
export const CreateTwilioProviderChatAccessDocument = gql`
    mutation CreateTwilioProviderChatAccess {
  createTwilioProviderChatAccess {
    jwt
  }
}
    `;
export type CreateTwilioProviderChatAccessMutationFn = Apollo.MutationFunction<CreateTwilioProviderChatAccessMutation, CreateTwilioProviderChatAccessMutationVariables>;

/**
 * __useCreateTwilioProviderChatAccessMutation__
 *
 * To run a mutation, you first call `useCreateTwilioProviderChatAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioProviderChatAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioProviderChatAccessMutation, { data, loading, error }] = useCreateTwilioProviderChatAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateTwilioProviderChatAccessMutation(baseOptions?: Apollo.MutationHookOptions<CreateTwilioProviderChatAccessMutation, CreateTwilioProviderChatAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTwilioProviderChatAccessMutation, CreateTwilioProviderChatAccessMutationVariables>(CreateTwilioProviderChatAccessDocument, options);
      }
export type CreateTwilioProviderChatAccessMutationHookResult = ReturnType<typeof useCreateTwilioProviderChatAccessMutation>;
export type CreateTwilioProviderChatAccessMutationResult = Apollo.MutationResult<CreateTwilioProviderChatAccessMutation>;
export type CreateTwilioProviderChatAccessMutationOptions = Apollo.BaseMutationOptions<CreateTwilioProviderChatAccessMutation, CreateTwilioProviderChatAccessMutationVariables>;
export const CreateTwilioSessionConversationDocument = gql`
    mutation CreateTwilioSessionConversation($roomSid: String!, $visitorId: String!, $visitorName: String!) {
  createTwilioSessionConversation(
    roomSid: $roomSid
    visitorId: $visitorId
    visitorName: $visitorName
  ) {
    conversationSid
  }
}
    `;
export type CreateTwilioSessionConversationMutationFn = Apollo.MutationFunction<CreateTwilioSessionConversationMutation, CreateTwilioSessionConversationMutationVariables>;

/**
 * __useCreateTwilioSessionConversationMutation__
 *
 * To run a mutation, you first call `useCreateTwilioSessionConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioSessionConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioSessionConversationMutation, { data, loading, error }] = useCreateTwilioSessionConversationMutation({
 *   variables: {
 *      roomSid: // value for 'roomSid'
 *      visitorId: // value for 'visitorId'
 *      visitorName: // value for 'visitorName'
 *   },
 * });
 */
export function useCreateTwilioSessionConversationMutation(baseOptions?: Apollo.MutationHookOptions<CreateTwilioSessionConversationMutation, CreateTwilioSessionConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTwilioSessionConversationMutation, CreateTwilioSessionConversationMutationVariables>(CreateTwilioSessionConversationDocument, options);
      }
export type CreateTwilioSessionConversationMutationHookResult = ReturnType<typeof useCreateTwilioSessionConversationMutation>;
export type CreateTwilioSessionConversationMutationResult = Apollo.MutationResult<CreateTwilioSessionConversationMutation>;
export type CreateTwilioSessionConversationMutationOptions = Apollo.BaseMutationOptions<CreateTwilioSessionConversationMutation, CreateTwilioSessionConversationMutationVariables>;
export const UpdateTwilioSessionConversationDocument = gql`
    mutation UpdateTwilioSessionConversation($conversationSid: String!, $visitorId: String!, $visitorName: String!) {
  updateTwilioSessionConversation(
    conversationSid: $conversationSid
    visitorId: $visitorId
    visitorName: $visitorName
  ) {
    participantSid
  }
}
    `;
export type UpdateTwilioSessionConversationMutationFn = Apollo.MutationFunction<UpdateTwilioSessionConversationMutation, UpdateTwilioSessionConversationMutationVariables>;

/**
 * __useUpdateTwilioSessionConversationMutation__
 *
 * To run a mutation, you first call `useUpdateTwilioSessionConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTwilioSessionConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTwilioSessionConversationMutation, { data, loading, error }] = useUpdateTwilioSessionConversationMutation({
 *   variables: {
 *      conversationSid: // value for 'conversationSid'
 *      visitorId: // value for 'visitorId'
 *      visitorName: // value for 'visitorName'
 *   },
 * });
 */
export function useUpdateTwilioSessionConversationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTwilioSessionConversationMutation, UpdateTwilioSessionConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTwilioSessionConversationMutation, UpdateTwilioSessionConversationMutationVariables>(UpdateTwilioSessionConversationDocument, options);
      }
export type UpdateTwilioSessionConversationMutationHookResult = ReturnType<typeof useUpdateTwilioSessionConversationMutation>;
export type UpdateTwilioSessionConversationMutationResult = Apollo.MutationResult<UpdateTwilioSessionConversationMutation>;
export type UpdateTwilioSessionConversationMutationOptions = Apollo.BaseMutationOptions<UpdateTwilioSessionConversationMutation, UpdateTwilioSessionConversationMutationVariables>;
export const UpdateTwilioVisitorMeetingAccessDocument = gql`
    mutation UpdateTwilioVisitorMeetingAccess($conversationSid: String, $roomName: String!, $visitorName: String!, $visitorUuid: String!, $eventType: MeetingAccessEventType!, $patientShortId: String, $isZoomEnabled: Boolean, $admissionTransactionId: String) {
  updateTwilioVisitorMeetingAccess(
    conversationSid: $conversationSid
    roomName: $roomName
    visitorName: $visitorName
    visitorUuid: $visitorUuid
    eventType: $eventType
    patientShortId: $patientShortId
    isZoomEnabled: $isZoomEnabled
    admissionTransactionId: $admissionTransactionId
  ) {
    eventType
    updatedAt
    admissionTime
  }
}
    `;
export type UpdateTwilioVisitorMeetingAccessMutationFn = Apollo.MutationFunction<UpdateTwilioVisitorMeetingAccessMutation, UpdateTwilioVisitorMeetingAccessMutationVariables>;

/**
 * __useUpdateTwilioVisitorMeetingAccessMutation__
 *
 * To run a mutation, you first call `useUpdateTwilioVisitorMeetingAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTwilioVisitorMeetingAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTwilioVisitorMeetingAccessMutation, { data, loading, error }] = useUpdateTwilioVisitorMeetingAccessMutation({
 *   variables: {
 *      conversationSid: // value for 'conversationSid'
 *      roomName: // value for 'roomName'
 *      visitorName: // value for 'visitorName'
 *      visitorUuid: // value for 'visitorUuid'
 *      eventType: // value for 'eventType'
 *      patientShortId: // value for 'patientShortId'
 *      isZoomEnabled: // value for 'isZoomEnabled'
 *      admissionTransactionId: // value for 'admissionTransactionId'
 *   },
 * });
 */
export function useUpdateTwilioVisitorMeetingAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTwilioVisitorMeetingAccessMutation, UpdateTwilioVisitorMeetingAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTwilioVisitorMeetingAccessMutation, UpdateTwilioVisitorMeetingAccessMutationVariables>(UpdateTwilioVisitorMeetingAccessDocument, options);
      }
export type UpdateTwilioVisitorMeetingAccessMutationHookResult = ReturnType<typeof useUpdateTwilioVisitorMeetingAccessMutation>;
export type UpdateTwilioVisitorMeetingAccessMutationResult = Apollo.MutationResult<UpdateTwilioVisitorMeetingAccessMutation>;
export type UpdateTwilioVisitorMeetingAccessMutationOptions = Apollo.BaseMutationOptions<UpdateTwilioVisitorMeetingAccessMutation, UpdateTwilioVisitorMeetingAccessMutationVariables>;
export const CreateTwilioProviderMeetingAccessDocument = gql`
    mutation CreateTwilioProviderMeetingAccess($patientShortId: String!) {
  createTwilioProviderMeetingAccess(patientShortId: $patientShortId) {
    jwt
    appointmentShortId
    zoomJwt
  }
}
    `;
export type CreateTwilioProviderMeetingAccessMutationFn = Apollo.MutationFunction<CreateTwilioProviderMeetingAccessMutation, CreateTwilioProviderMeetingAccessMutationVariables>;

/**
 * __useCreateTwilioProviderMeetingAccessMutation__
 *
 * To run a mutation, you first call `useCreateTwilioProviderMeetingAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioProviderMeetingAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioProviderMeetingAccessMutation, { data, loading, error }] = useCreateTwilioProviderMeetingAccessMutation({
 *   variables: {
 *      patientShortId: // value for 'patientShortId'
 *   },
 * });
 */
export function useCreateTwilioProviderMeetingAccessMutation(baseOptions?: Apollo.MutationHookOptions<CreateTwilioProviderMeetingAccessMutation, CreateTwilioProviderMeetingAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTwilioProviderMeetingAccessMutation, CreateTwilioProviderMeetingAccessMutationVariables>(CreateTwilioProviderMeetingAccessDocument, options);
      }
export type CreateTwilioProviderMeetingAccessMutationHookResult = ReturnType<typeof useCreateTwilioProviderMeetingAccessMutation>;
export type CreateTwilioProviderMeetingAccessMutationResult = Apollo.MutationResult<CreateTwilioProviderMeetingAccessMutation>;
export type CreateTwilioProviderMeetingAccessMutationOptions = Apollo.BaseMutationOptions<CreateTwilioProviderMeetingAccessMutation, CreateTwilioProviderMeetingAccessMutationVariables>;
export const MarkAppointmentCompletedDocument = gql`
    mutation MarkAppointmentCompleted($appointmentShortId: String!) {
  markAppointmentCompleted(appointmentShortId: $appointmentShortId) {
    shortId
    completedAt
  }
}
    `;
export type MarkAppointmentCompletedMutationFn = Apollo.MutationFunction<MarkAppointmentCompletedMutation, MarkAppointmentCompletedMutationVariables>;

/**
 * __useMarkAppointmentCompletedMutation__
 *
 * To run a mutation, you first call `useMarkAppointmentCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkAppointmentCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markAppointmentCompletedMutation, { data, loading, error }] = useMarkAppointmentCompletedMutation({
 *   variables: {
 *      appointmentShortId: // value for 'appointmentShortId'
 *   },
 * });
 */
export function useMarkAppointmentCompletedMutation(baseOptions?: Apollo.MutationHookOptions<MarkAppointmentCompletedMutation, MarkAppointmentCompletedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkAppointmentCompletedMutation, MarkAppointmentCompletedMutationVariables>(MarkAppointmentCompletedDocument, options);
      }
export type MarkAppointmentCompletedMutationHookResult = ReturnType<typeof useMarkAppointmentCompletedMutation>;
export type MarkAppointmentCompletedMutationResult = Apollo.MutationResult<MarkAppointmentCompletedMutation>;
export type MarkAppointmentCompletedMutationOptions = Apollo.BaseMutationOptions<MarkAppointmentCompletedMutation, MarkAppointmentCompletedMutationVariables>;
export const GetPresignedUrlDocument = gql`
    mutation GetPresignedUrl($appointmentShortId: String!, $uploadMeta: UploadMeta) {
  getPresignedUrl(
    appointmentShortId: $appointmentShortId
    uploadMeta: $uploadMeta
  ) {
    url
  }
}
    `;
export type GetPresignedUrlMutationFn = Apollo.MutationFunction<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>;

/**
 * __useGetPresignedUrlMutation__
 *
 * To run a mutation, you first call `useGetPresignedUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetPresignedUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getPresignedUrlMutation, { data, loading, error }] = useGetPresignedUrlMutation({
 *   variables: {
 *      appointmentShortId: // value for 'appointmentShortId'
 *      uploadMeta: // value for 'uploadMeta'
 *   },
 * });
 */
export function useGetPresignedUrlMutation(baseOptions?: Apollo.MutationHookOptions<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>(GetPresignedUrlDocument, options);
      }
export type GetPresignedUrlMutationHookResult = ReturnType<typeof useGetPresignedUrlMutation>;
export type GetPresignedUrlMutationResult = Apollo.MutationResult<GetPresignedUrlMutation>;
export type GetPresignedUrlMutationOptions = Apollo.BaseMutationOptions<GetPresignedUrlMutation, GetPresignedUrlMutationVariables>;
export const GetProviderPatientTranscriptionConsentDocument = gql`
    query GetProviderPatientTranscriptionConsent($patientShortId: String!, $providerShortId: String!) {
  clientTranscriptionConsent(patientShortId: $patientShortId) {
    isOptedIn
    updateSource
  }
  providerTranscriptionConsent(providerShortId: $providerShortId) {
    isOptedIn
    updateSource
  }
}
    `;

/**
 * __useGetProviderPatientTranscriptionConsentQuery__
 *
 * To run a query within a React component, call `useGetProviderPatientTranscriptionConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderPatientTranscriptionConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderPatientTranscriptionConsentQuery({
 *   variables: {
 *      patientShortId: // value for 'patientShortId'
 *      providerShortId: // value for 'providerShortId'
 *   },
 * });
 */
export function useGetProviderPatientTranscriptionConsentQuery(baseOptions: Apollo.QueryHookOptions<GetProviderPatientTranscriptionConsentQuery, GetProviderPatientTranscriptionConsentQueryVariables> & ({ variables: GetProviderPatientTranscriptionConsentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderPatientTranscriptionConsentQuery, GetProviderPatientTranscriptionConsentQueryVariables>(GetProviderPatientTranscriptionConsentDocument, options);
      }
export function useGetProviderPatientTranscriptionConsentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderPatientTranscriptionConsentQuery, GetProviderPatientTranscriptionConsentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderPatientTranscriptionConsentQuery, GetProviderPatientTranscriptionConsentQueryVariables>(GetProviderPatientTranscriptionConsentDocument, options);
        }
export function useGetProviderPatientTranscriptionConsentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderPatientTranscriptionConsentQuery, GetProviderPatientTranscriptionConsentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderPatientTranscriptionConsentQuery, GetProviderPatientTranscriptionConsentQueryVariables>(GetProviderPatientTranscriptionConsentDocument, options);
        }
export type GetProviderPatientTranscriptionConsentQueryHookResult = ReturnType<typeof useGetProviderPatientTranscriptionConsentQuery>;
export type GetProviderPatientTranscriptionConsentLazyQueryHookResult = ReturnType<typeof useGetProviderPatientTranscriptionConsentLazyQuery>;
export type GetProviderPatientTranscriptionConsentSuspenseQueryHookResult = ReturnType<typeof useGetProviderPatientTranscriptionConsentSuspenseQuery>;
export type GetProviderPatientTranscriptionConsentQueryResult = Apollo.QueryResult<GetProviderPatientTranscriptionConsentQuery, GetProviderPatientTranscriptionConsentQueryVariables>;
export const GetProviderTranscriptionConsentDocument = gql`
    query GetProviderTranscriptionConsent($providerShortId: String!) {
  providerTranscriptionConsent(providerShortId: $providerShortId) {
    isOptedIn
    updateSource
  }
}
    `;

/**
 * __useGetProviderTranscriptionConsentQuery__
 *
 * To run a query within a React component, call `useGetProviderTranscriptionConsentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProviderTranscriptionConsentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProviderTranscriptionConsentQuery({
 *   variables: {
 *      providerShortId: // value for 'providerShortId'
 *   },
 * });
 */
export function useGetProviderTranscriptionConsentQuery(baseOptions: Apollo.QueryHookOptions<GetProviderTranscriptionConsentQuery, GetProviderTranscriptionConsentQueryVariables> & ({ variables: GetProviderTranscriptionConsentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetProviderTranscriptionConsentQuery, GetProviderTranscriptionConsentQueryVariables>(GetProviderTranscriptionConsentDocument, options);
      }
export function useGetProviderTranscriptionConsentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetProviderTranscriptionConsentQuery, GetProviderTranscriptionConsentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetProviderTranscriptionConsentQuery, GetProviderTranscriptionConsentQueryVariables>(GetProviderTranscriptionConsentDocument, options);
        }
export function useGetProviderTranscriptionConsentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetProviderTranscriptionConsentQuery, GetProviderTranscriptionConsentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetProviderTranscriptionConsentQuery, GetProviderTranscriptionConsentQueryVariables>(GetProviderTranscriptionConsentDocument, options);
        }
export type GetProviderTranscriptionConsentQueryHookResult = ReturnType<typeof useGetProviderTranscriptionConsentQuery>;
export type GetProviderTranscriptionConsentLazyQueryHookResult = ReturnType<typeof useGetProviderTranscriptionConsentLazyQuery>;
export type GetProviderTranscriptionConsentSuspenseQueryHookResult = ReturnType<typeof useGetProviderTranscriptionConsentSuspenseQuery>;
export type GetProviderTranscriptionConsentQueryResult = Apollo.QueryResult<GetProviderTranscriptionConsentQuery, GetProviderTranscriptionConsentQueryVariables>;
export const RecordProviderTranscriptionConsentDocument = gql`
    mutation RecordProviderTranscriptionConsent($providerShortId: String!, $isOptedIn: Boolean!, $updateSource: String!, $appointmentShortId: String) {
  recordProviderTranscriptionConsent(
    providerShortId: $providerShortId
    isOptedIn: $isOptedIn
    updateSource: $updateSource
    appointmentShortId: $appointmentShortId
  ) {
    providerShortId
    isOptedIn
    createdAt
  }
}
    `;
export type RecordProviderTranscriptionConsentMutationFn = Apollo.MutationFunction<RecordProviderTranscriptionConsentMutation, RecordProviderTranscriptionConsentMutationVariables>;

/**
 * __useRecordProviderTranscriptionConsentMutation__
 *
 * To run a mutation, you first call `useRecordProviderTranscriptionConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProviderTranscriptionConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProviderTranscriptionConsentMutation, { data, loading, error }] = useRecordProviderTranscriptionConsentMutation({
 *   variables: {
 *      providerShortId: // value for 'providerShortId'
 *      isOptedIn: // value for 'isOptedIn'
 *      updateSource: // value for 'updateSource'
 *      appointmentShortId: // value for 'appointmentShortId'
 *   },
 * });
 */
export function useRecordProviderTranscriptionConsentMutation(baseOptions?: Apollo.MutationHookOptions<RecordProviderTranscriptionConsentMutation, RecordProviderTranscriptionConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProviderTranscriptionConsentMutation, RecordProviderTranscriptionConsentMutationVariables>(RecordProviderTranscriptionConsentDocument, options);
      }
export type RecordProviderTranscriptionConsentMutationHookResult = ReturnType<typeof useRecordProviderTranscriptionConsentMutation>;
export type RecordProviderTranscriptionConsentMutationResult = Apollo.MutationResult<RecordProviderTranscriptionConsentMutation>;
export type RecordProviderTranscriptionConsentMutationOptions = Apollo.BaseMutationOptions<RecordProviderTranscriptionConsentMutation, RecordProviderTranscriptionConsentMutationVariables>;
export const CreateTwilioVisitorPresenceMapAccessDocument = gql`
    mutation CreateTwilioVisitorPresenceMapAccess {
  createTwilioVisitorPresenceMapAccess {
    jwt
    visitorPresenceMapSid
  }
}
    `;
export type CreateTwilioVisitorPresenceMapAccessMutationFn = Apollo.MutationFunction<CreateTwilioVisitorPresenceMapAccessMutation, CreateTwilioVisitorPresenceMapAccessMutationVariables>;

/**
 * __useCreateTwilioVisitorPresenceMapAccessMutation__
 *
 * To run a mutation, you first call `useCreateTwilioVisitorPresenceMapAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioVisitorPresenceMapAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioVisitorPresenceMapAccessMutation, { data, loading, error }] = useCreateTwilioVisitorPresenceMapAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateTwilioVisitorPresenceMapAccessMutation(baseOptions?: Apollo.MutationHookOptions<CreateTwilioVisitorPresenceMapAccessMutation, CreateTwilioVisitorPresenceMapAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTwilioVisitorPresenceMapAccessMutation, CreateTwilioVisitorPresenceMapAccessMutationVariables>(CreateTwilioVisitorPresenceMapAccessDocument, options);
      }
export type CreateTwilioVisitorPresenceMapAccessMutationHookResult = ReturnType<typeof useCreateTwilioVisitorPresenceMapAccessMutation>;
export type CreateTwilioVisitorPresenceMapAccessMutationResult = Apollo.MutationResult<CreateTwilioVisitorPresenceMapAccessMutation>;
export type CreateTwilioVisitorPresenceMapAccessMutationOptions = Apollo.BaseMutationOptions<CreateTwilioVisitorPresenceMapAccessMutation, CreateTwilioVisitorPresenceMapAccessMutationVariables>;
export const DisconnectTwilioParticipantDocument = gql`
    mutation DisconnectTwilioParticipant($roomName: String!, $participantSid: String!) {
  disconnectTwilioParticipant(
    roomName: $roomName
    participantSid: $participantSid
  ) {
    roomName
    participantSid
  }
}
    `;
export type DisconnectTwilioParticipantMutationFn = Apollo.MutationFunction<DisconnectTwilioParticipantMutation, DisconnectTwilioParticipantMutationVariables>;

/**
 * __useDisconnectTwilioParticipantMutation__
 *
 * To run a mutation, you first call `useDisconnectTwilioParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectTwilioParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectTwilioParticipantMutation, { data, loading, error }] = useDisconnectTwilioParticipantMutation({
 *   variables: {
 *      roomName: // value for 'roomName'
 *      participantSid: // value for 'participantSid'
 *   },
 * });
 */
export function useDisconnectTwilioParticipantMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectTwilioParticipantMutation, DisconnectTwilioParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectTwilioParticipantMutation, DisconnectTwilioParticipantMutationVariables>(DisconnectTwilioParticipantDocument, options);
      }
export type DisconnectTwilioParticipantMutationHookResult = ReturnType<typeof useDisconnectTwilioParticipantMutation>;
export type DisconnectTwilioParticipantMutationResult = Apollo.MutationResult<DisconnectTwilioParticipantMutation>;
export type DisconnectTwilioParticipantMutationOptions = Apollo.BaseMutationOptions<DisconnectTwilioParticipantMutation, DisconnectTwilioParticipantMutationVariables>;
export const GetCurrentProviderDocument = gql`
    query GetCurrentProvider {
  currentProvider {
    shortId
    name
    image
    pronouns
    isPrescriber
  }
}
    `;

/**
 * __useGetCurrentProviderQuery__
 *
 * To run a query within a React component, call `useGetCurrentProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentProviderQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCurrentProviderQuery(baseOptions?: Apollo.QueryHookOptions<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>(GetCurrentProviderDocument, options);
      }
export function useGetCurrentProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>(GetCurrentProviderDocument, options);
        }
export function useGetCurrentProviderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>(GetCurrentProviderDocument, options);
        }
export type GetCurrentProviderQueryHookResult = ReturnType<typeof useGetCurrentProviderQuery>;
export type GetCurrentProviderLazyQueryHookResult = ReturnType<typeof useGetCurrentProviderLazyQuery>;
export type GetCurrentProviderSuspenseQueryHookResult = ReturnType<typeof useGetCurrentProviderSuspenseQuery>;
export type GetCurrentProviderQueryResult = Apollo.QueryResult<GetCurrentProviderQuery, GetCurrentProviderQueryVariables>;
export const RecordUnaccompaniedParticipantDocument = gql`
    mutation RecordUnaccompaniedParticipant($entityShortId: String!, $entityType: UserType!, $name: String!) {
  recordUnaccompaniedParticipant(
    entityShortId: $entityShortId
    entityType: $entityType
    name: $name
  ) {
    entityShortId
  }
}
    `;
export type RecordUnaccompaniedParticipantMutationFn = Apollo.MutationFunction<RecordUnaccompaniedParticipantMutation, RecordUnaccompaniedParticipantMutationVariables>;

/**
 * __useRecordUnaccompaniedParticipantMutation__
 *
 * To run a mutation, you first call `useRecordUnaccompaniedParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordUnaccompaniedParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordUnaccompaniedParticipantMutation, { data, loading, error }] = useRecordUnaccompaniedParticipantMutation({
 *   variables: {
 *      entityShortId: // value for 'entityShortId'
 *      entityType: // value for 'entityType'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRecordUnaccompaniedParticipantMutation(baseOptions?: Apollo.MutationHookOptions<RecordUnaccompaniedParticipantMutation, RecordUnaccompaniedParticipantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordUnaccompaniedParticipantMutation, RecordUnaccompaniedParticipantMutationVariables>(RecordUnaccompaniedParticipantDocument, options);
      }
export type RecordUnaccompaniedParticipantMutationHookResult = ReturnType<typeof useRecordUnaccompaniedParticipantMutation>;
export type RecordUnaccompaniedParticipantMutationResult = Apollo.MutationResult<RecordUnaccompaniedParticipantMutation>;
export type RecordUnaccompaniedParticipantMutationOptions = Apollo.BaseMutationOptions<RecordUnaccompaniedParticipantMutation, RecordUnaccompaniedParticipantMutationVariables>;
export const RecordClientTranscriptionConsentDocument = gql`
    mutation RecordClientTranscriptionConsent($patientShortId: String!, $providerShortId: String!, $isOptedIn: Boolean!, $updateSource: String!, $appointmentShortId: String, $userAction: String) {
  recordClientTranscriptionConsent(
    patientShortId: $patientShortId
    providerShortId: $providerShortId
    isOptedIn: $isOptedIn
    updateSource: $updateSource
    appointmentShortId: $appointmentShortId
    userAction: $userAction
  ) {
    patientShortId
    isOptedIn
    createdAt
  }
}
    `;
export type RecordClientTranscriptionConsentMutationFn = Apollo.MutationFunction<RecordClientTranscriptionConsentMutation, RecordClientTranscriptionConsentMutationVariables>;

/**
 * __useRecordClientTranscriptionConsentMutation__
 *
 * To run a mutation, you first call `useRecordClientTranscriptionConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordClientTranscriptionConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordClientTranscriptionConsentMutation, { data, loading, error }] = useRecordClientTranscriptionConsentMutation({
 *   variables: {
 *      patientShortId: // value for 'patientShortId'
 *      providerShortId: // value for 'providerShortId'
 *      isOptedIn: // value for 'isOptedIn'
 *      updateSource: // value for 'updateSource'
 *      appointmentShortId: // value for 'appointmentShortId'
 *      userAction: // value for 'userAction'
 *   },
 * });
 */
export function useRecordClientTranscriptionConsentMutation(baseOptions?: Apollo.MutationHookOptions<RecordClientTranscriptionConsentMutation, RecordClientTranscriptionConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordClientTranscriptionConsentMutation, RecordClientTranscriptionConsentMutationVariables>(RecordClientTranscriptionConsentDocument, options);
      }
export type RecordClientTranscriptionConsentMutationHookResult = ReturnType<typeof useRecordClientTranscriptionConsentMutation>;
export type RecordClientTranscriptionConsentMutationResult = Apollo.MutationResult<RecordClientTranscriptionConsentMutation>;
export type RecordClientTranscriptionConsentMutationOptions = Apollo.BaseMutationOptions<RecordClientTranscriptionConsentMutation, RecordClientTranscriptionConsentMutationVariables>;
export const GetCurrentPatientDocument = gql`
    query GetCurrentPatient($patientShortId: String!) {
  patientInfo(patientShortId: $patientShortId) {
    preferredName
  }
}
    `;

/**
 * __useGetCurrentPatientQuery__
 *
 * To run a query within a React component, call `useGetCurrentPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentPatientQuery({
 *   variables: {
 *      patientShortId: // value for 'patientShortId'
 *   },
 * });
 */
export function useGetCurrentPatientQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentPatientQuery, GetCurrentPatientQueryVariables> & ({ variables: GetCurrentPatientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentPatientQuery, GetCurrentPatientQueryVariables>(GetCurrentPatientDocument, options);
      }
export function useGetCurrentPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentPatientQuery, GetCurrentPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentPatientQuery, GetCurrentPatientQueryVariables>(GetCurrentPatientDocument, options);
        }
export function useGetCurrentPatientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentPatientQuery, GetCurrentPatientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentPatientQuery, GetCurrentPatientQueryVariables>(GetCurrentPatientDocument, options);
        }
export type GetCurrentPatientQueryHookResult = ReturnType<typeof useGetCurrentPatientQuery>;
export type GetCurrentPatientLazyQueryHookResult = ReturnType<typeof useGetCurrentPatientLazyQuery>;
export type GetCurrentPatientSuspenseQueryHookResult = ReturnType<typeof useGetCurrentPatientSuspenseQuery>;
export type GetCurrentPatientQueryResult = Apollo.QueryResult<GetCurrentPatientQuery, GetCurrentPatientQueryVariables>;
export const RecordClientMeasureVisitorDocument = gql`
    mutation RecordClientMeasureVisitor($visitorId: String!, $providerShortId: String) {
  recordClientMeasure(visitorId: $visitorId, providerShortId: $providerShortId) {
    recordedAt
  }
}
    `;
export type RecordClientMeasureVisitorMutationFn = Apollo.MutationFunction<RecordClientMeasureVisitorMutation, RecordClientMeasureVisitorMutationVariables>;

/**
 * __useRecordClientMeasureVisitorMutation__
 *
 * To run a mutation, you first call `useRecordClientMeasureVisitorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordClientMeasureVisitorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordClientMeasureVisitorMutation, { data, loading, error }] = useRecordClientMeasureVisitorMutation({
 *   variables: {
 *      visitorId: // value for 'visitorId'
 *      providerShortId: // value for 'providerShortId'
 *   },
 * });
 */
export function useRecordClientMeasureVisitorMutation(baseOptions?: Apollo.MutationHookOptions<RecordClientMeasureVisitorMutation, RecordClientMeasureVisitorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordClientMeasureVisitorMutation, RecordClientMeasureVisitorMutationVariables>(RecordClientMeasureVisitorDocument, options);
      }
export type RecordClientMeasureVisitorMutationHookResult = ReturnType<typeof useRecordClientMeasureVisitorMutation>;
export type RecordClientMeasureVisitorMutationResult = Apollo.MutationResult<RecordClientMeasureVisitorMutation>;
export type RecordClientMeasureVisitorMutationOptions = Apollo.BaseMutationOptions<RecordClientMeasureVisitorMutation, RecordClientMeasureVisitorMutationVariables>;
export const CreateTwilioVisitorChatExperienceDocument = gql`
    mutation CreateTwilioVisitorChatExperience($providerShortId: String!, $visitorName: String!, $visitorId: String!) {
  createTwilioVisitorChatAccess(visitorName: $visitorName, visitorId: $visitorId) {
    jwt
  }
  createTwilioWaitingRoomConversation(
    providerShortId: $providerShortId
    visitorUuid: $visitorId
    visitorName: $visitorName
  ) {
    conversationSid
  }
}
    `;
export type CreateTwilioVisitorChatExperienceMutationFn = Apollo.MutationFunction<CreateTwilioVisitorChatExperienceMutation, CreateTwilioVisitorChatExperienceMutationVariables>;

/**
 * __useCreateTwilioVisitorChatExperienceMutation__
 *
 * To run a mutation, you first call `useCreateTwilioVisitorChatExperienceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioVisitorChatExperienceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioVisitorChatExperienceMutation, { data, loading, error }] = useCreateTwilioVisitorChatExperienceMutation({
 *   variables: {
 *      providerShortId: // value for 'providerShortId'
 *      visitorName: // value for 'visitorName'
 *      visitorId: // value for 'visitorId'
 *   },
 * });
 */
export function useCreateTwilioVisitorChatExperienceMutation(baseOptions?: Apollo.MutationHookOptions<CreateTwilioVisitorChatExperienceMutation, CreateTwilioVisitorChatExperienceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTwilioVisitorChatExperienceMutation, CreateTwilioVisitorChatExperienceMutationVariables>(CreateTwilioVisitorChatExperienceDocument, options);
      }
export type CreateTwilioVisitorChatExperienceMutationHookResult = ReturnType<typeof useCreateTwilioVisitorChatExperienceMutation>;
export type CreateTwilioVisitorChatExperienceMutationResult = Apollo.MutationResult<CreateTwilioVisitorChatExperienceMutation>;
export type CreateTwilioVisitorChatExperienceMutationOptions = Apollo.BaseMutationOptions<CreateTwilioVisitorChatExperienceMutation, CreateTwilioVisitorChatExperienceMutationVariables>;
export const CreateTwilioVisitorAccessDocTokenDocument = gql`
    mutation CreateTwilioVisitorAccessDocToken($providerShortId: String!, $visitorName: String!, $visitorUuid: String!) {
  createTwilioVisitorAccess(
    providerShortId: $providerShortId
    visitorName: $visitorName
    visitorUuid: $visitorUuid
  ) {
    jwt
    visitorAccessDocSid
  }
}
    `;
export type CreateTwilioVisitorAccessDocTokenMutationFn = Apollo.MutationFunction<CreateTwilioVisitorAccessDocTokenMutation, CreateTwilioVisitorAccessDocTokenMutationVariables>;

/**
 * __useCreateTwilioVisitorAccessDocTokenMutation__
 *
 * To run a mutation, you first call `useCreateTwilioVisitorAccessDocTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTwilioVisitorAccessDocTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTwilioVisitorAccessDocTokenMutation, { data, loading, error }] = useCreateTwilioVisitorAccessDocTokenMutation({
 *   variables: {
 *      providerShortId: // value for 'providerShortId'
 *      visitorName: // value for 'visitorName'
 *      visitorUuid: // value for 'visitorUuid'
 *   },
 * });
 */
export function useCreateTwilioVisitorAccessDocTokenMutation(baseOptions?: Apollo.MutationHookOptions<CreateTwilioVisitorAccessDocTokenMutation, CreateTwilioVisitorAccessDocTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTwilioVisitorAccessDocTokenMutation, CreateTwilioVisitorAccessDocTokenMutationVariables>(CreateTwilioVisitorAccessDocTokenDocument, options);
      }
export type CreateTwilioVisitorAccessDocTokenMutationHookResult = ReturnType<typeof useCreateTwilioVisitorAccessDocTokenMutation>;
export type CreateTwilioVisitorAccessDocTokenMutationResult = Apollo.MutationResult<CreateTwilioVisitorAccessDocTokenMutation>;
export type CreateTwilioVisitorAccessDocTokenMutationOptions = Apollo.BaseMutationOptions<CreateTwilioVisitorAccessDocTokenMutation, CreateTwilioVisitorAccessDocTokenMutationVariables>;
export const RecordProviderNoShowReportDocument = gql`
    mutation RecordProviderNoShowReport($appointmentShortId: String!, $patientName: String!) {
  recordProviderNoShowReport(
    appointmentShortId: $appointmentShortId
    patientName: $patientName
  ) {
    appointmentShortId
    createdAt
  }
}
    `;
export type RecordProviderNoShowReportMutationFn = Apollo.MutationFunction<RecordProviderNoShowReportMutation, RecordProviderNoShowReportMutationVariables>;

/**
 * __useRecordProviderNoShowReportMutation__
 *
 * To run a mutation, you first call `useRecordProviderNoShowReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRecordProviderNoShowReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [recordProviderNoShowReportMutation, { data, loading, error }] = useRecordProviderNoShowReportMutation({
 *   variables: {
 *      appointmentShortId: // value for 'appointmentShortId'
 *      patientName: // value for 'patientName'
 *   },
 * });
 */
export function useRecordProviderNoShowReportMutation(baseOptions?: Apollo.MutationHookOptions<RecordProviderNoShowReportMutation, RecordProviderNoShowReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RecordProviderNoShowReportMutation, RecordProviderNoShowReportMutationVariables>(RecordProviderNoShowReportDocument, options);
      }
export type RecordProviderNoShowReportMutationHookResult = ReturnType<typeof useRecordProviderNoShowReportMutation>;
export type RecordProviderNoShowReportMutationResult = Apollo.MutationResult<RecordProviderNoShowReportMutation>;
export type RecordProviderNoShowReportMutationOptions = Apollo.BaseMutationOptions<RecordProviderNoShowReportMutation, RecordProviderNoShowReportMutationVariables>;
export const UpdateVisitorPresenceDocument = gql`
    mutation UpdateVisitorPresence($providerShortId: String!, $patientShortId: String!, $appointmentShortId: String, $visitorUuid: String!, $visitorName: String!, $waitingRoomConversationSid: String, $videoPlatform: String, $joinRoomMode: String, $admissionTime: String, $isInForeground: Boolean, $isJoining: Boolean) {
  updateTwilioVisitorPresence(
    providerShortId: $providerShortId
    patientShortId: $patientShortId
    appointmentShortId: $appointmentShortId
    visitorUuid: $visitorUuid
    visitorName: $visitorName
    waitingRoomConversationSid: $waitingRoomConversationSid
    videoPlatform: $videoPlatform
    joinRoomMode: $joinRoomMode
    admissionTime: $admissionTime
    isInForeground: $isInForeground
    isJoining: $isJoining
  ) {
    updatedAt
  }
}
    `;
export type UpdateVisitorPresenceMutationFn = Apollo.MutationFunction<UpdateVisitorPresenceMutation, UpdateVisitorPresenceMutationVariables>;

/**
 * __useUpdateVisitorPresenceMutation__
 *
 * To run a mutation, you first call `useUpdateVisitorPresenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVisitorPresenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVisitorPresenceMutation, { data, loading, error }] = useUpdateVisitorPresenceMutation({
 *   variables: {
 *      providerShortId: // value for 'providerShortId'
 *      patientShortId: // value for 'patientShortId'
 *      appointmentShortId: // value for 'appointmentShortId'
 *      visitorUuid: // value for 'visitorUuid'
 *      visitorName: // value for 'visitorName'
 *      waitingRoomConversationSid: // value for 'waitingRoomConversationSid'
 *      videoPlatform: // value for 'videoPlatform'
 *      joinRoomMode: // value for 'joinRoomMode'
 *      admissionTime: // value for 'admissionTime'
 *      isInForeground: // value for 'isInForeground'
 *      isJoining: // value for 'isJoining'
 *   },
 * });
 */
export function useUpdateVisitorPresenceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVisitorPresenceMutation, UpdateVisitorPresenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVisitorPresenceMutation, UpdateVisitorPresenceMutationVariables>(UpdateVisitorPresenceDocument, options);
      }
export type UpdateVisitorPresenceMutationHookResult = ReturnType<typeof useUpdateVisitorPresenceMutation>;
export type UpdateVisitorPresenceMutationResult = Apollo.MutationResult<UpdateVisitorPresenceMutation>;
export type UpdateVisitorPresenceMutationOptions = Apollo.BaseMutationOptions<UpdateVisitorPresenceMutation, UpdateVisitorPresenceMutationVariables>;